module.exports = __webpack_public_path__ + "static/img/bg-fr.7f7616f3.webp";